var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconClock = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M12 2.25C6.61575 2.25 2.25 6.61575 2.25 12C2.25 17.3842 6.61575 21.75 12 21.75C17.3842 21.75 21.75 17.3842 21.75 12C21.75 6.61575 17.3842 2.25 12 2.25ZM3.78375 11.25C4.1625 7.0455 7.69725 3.75 12 3.75C16.3027 3.75 19.8375 7.0455 20.2162 11.25H19.5C19.086 11.25 18.75 11.586 18.75 12C18.75 12.414 19.086 12.75 19.5 12.75H20.2162C19.8592 16.7078 16.7078 19.86 12.75 20.2162V19.5C12.75 19.086 12.414 18.75 12 18.75C11.586 18.75 11.25 19.086 11.25 19.5V20.2162C7.29225 19.8592 4.14 16.7078 3.78375 12.75H4.5C4.914 12.75 5.25 12.414 5.25 12C5.25 11.586 4.914 11.25 4.5 11.25H3.78375ZM12.5445 12.516C12.495 12.5693 12.4372 12.6157 12.3705 12.654L9.123 14.529C8.7645 14.736 8.3055 14.613 8.0985 14.2545C7.8915 13.896 8.0145 13.437 8.373 13.23L11.25 11.5688V6C11.25 5.586 11.586 5.25 12 5.25C12.414 5.25 12.75 5.586 12.75 6V12C12.75 12.2002 12.672 12.3818 12.5445 12.516Z", fill: "black" }))),
        alt: 'Clock',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconClock;
//# sourceMappingURL=index.js.map